import React, { useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import { Button, Spinner, StrokeIcon } from "./ui";

const DonwloadModFileButton = ({
  fileId,
  fileName,
  status,
  price_status,
  isTable,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/files/${fileId}/download-mod-file`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  if (!(status === "PROCESSED" && price_status === "PAID")) {
    return null;
  }

  // Inside a table the action is just an icon in a cell; on the file page it is
  // a full button alongside the original-file download.
  if (isTable) {
    return (
      <button
        onClick={handleDownload}
        disabled={loading}
        title="Download modified file"
        aria-label="Download modified file"
        className="inline-flex h-8 w-8 items-center justify-center rounded-full text-emerald-600 transition hover:bg-emerald-500/10 disabled:opacity-50 dark:text-emerald-400"
      >
        {loading ? (
          <Spinner />
        ) : (
          <StrokeIcon className="h-5 w-5">
            <path d="M12 3v12M7 12l5 5 5-5" />
            <path d="M5 21h14" />
          </StrokeIcon>
        )}
      </button>
    );
  }

  return (
    <Button variant="success" onClick={handleDownload} disabled={loading} className="w-full">
      {loading ? (
        <Spinner />
      ) : (
        <StrokeIcon className="h-5 w-5">
          <path d="M12 3v12M7 12l5 5 5-5" />
          <path d="M5 21h14" />
        </StrokeIcon>
      )}
      {loading ? "Downloading…" : "Download Modified File"}
    </Button>
  );
};

export default DonwloadModFileButton;
